import {
  CalendarDaysIcon,
  ClipboardListIcon,
  Mail,
  MapPinIcon,
  PhoneCallIcon,
} from 'assets/icons';

// The types of a task, as the api stores them: their icon, and the colour of
// their badge (components/badge, the sector tags of jobbiz_app_v2). Labels
// live in the locales (taskTypes).
export const TASK_TYPES = {
  todo: { icon: ClipboardListIcon, badge: 'SECTOR_GREY' },
  call: { icon: PhoneCallIcon, badge: 'SECTOR_BLUE' },
  email: { icon: Mail, badge: 'SECTOR_ORANGE' },
  visit: { icon: MapPinIcon, badge: 'SECTOR_GREEN' },
  meeting: { icon: CalendarDaysIcon, badge: 'SECTOR_PURPLE' },
};

export const taskTypeOf = (type) => TASK_TYPES[type] ?? TASK_TYPES.todo;

export const taskTypeLabel = (language, type) =>
  language.getValue(`taskTypes.${type in TASK_TYPES ? type : 'todo'}`, '');
